// store/slices/myAccountSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMyStatement, getMyMovements } from "../../utils/accountApi";
import { logoutUser } from "./usersSlice";

/* ================= INITIAL STATE ================= */

const initialState = {
  statement: null,
  client: null,
  movements: [],
  balance: 0,
  noAccount: false,
  loading: false,
  error: null,
};

function rejectWithStatus(err) {
  return {
    message: err.response?.data?.message || err.message,
    status: err.response?.status ?? null,
  };
}

/* ================= THUNKS ================= */

export const fetchMyStatement = createAsyncThunk(
  "myAccount/fetchStatement",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getMyStatement();
      return data;
    } catch (err) {
      return rejectWithValue(rejectWithStatus(err));
    }
  }
);

export const fetchMyMovements = createAsyncThunk(
  "myAccount/fetchMovements",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getMyMovements();
      return data;
    } catch (err) {
      return rejectWithValue(rejectWithStatus(err));
    }
  }
);

/* ================= SLICE ================= */

const myAccountSlice = createSlice({
  name: "myAccount",
  initialState,
  reducers: {
    clearMyAccountError(state) {
      state.error = null;
      state.noAccount = false;
    },
    resetMyAccount() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      /* ===== ESTADO DE CUENTA ===== */
      .addCase(fetchMyStatement.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.noAccount = false;
      })
      .addCase(fetchMyStatement.fulfilled, (state, action) => {
        state.loading = false;
        state.statement = action.payload;
        state.client = action.payload.client;
        state.balance = action.payload.balance;
        state.noAccount = false;
      })
      .addCase(fetchMyStatement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.noAccount = action.payload?.status === 404;
        state.statement = null;
        state.client = null;
      })

      /* ===== HISTORIAL ===== */
      .addCase(fetchMyMovements.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.noAccount = false;
      })
      .addCase(fetchMyMovements.fulfilled, (state, action) => {
        state.loading = false;
        state.movements = action.payload.movements;
        state.balance = action.payload.balance;
        state.noAccount = false;
      })
      .addCase(fetchMyMovements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.noAccount = action.payload?.status === 404;
        state.movements = [];
      })

      /* ===== LOGOUT ===== */
      .addCase(logoutUser, () => initialState);
  },
});

export const { clearMyAccountError, resetMyAccount } =
  myAccountSlice.actions;
export default myAccountSlice.reducer;
